import React from 'react';
import { LayoutComposer } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { NamedLink } from '../../components';
import css from './AboutPage.module.css';

const AboutPage = () => {
    const layoutAreas = `
        topbar
        main
        footer
    `;

    return (
        <LayoutComposer areas={layoutAreas} className={css.root}>
            {layoutProps => {
                const { Topbar, Main, Footer } = layoutProps;
                return (
                    <>
                        <Topbar as="header" className={css.topbar}>
                            <TopbarContainer currentPage="AboutPage" />
                        </Topbar>
                        <Main as="main" className={css.main}>
                            <div className={css.content}>
                                <h1 className={css.title}>Quiénes Somos</h1>
                                <p className={css.intro}>
                                    BioCerca nació de una idea sencilla, pero poderosa:
                                    volver a mirar a la tierra y a quienes la cuidan con las manos.
                                </p>
                                <div className={css.bodyText}>
                                    <p>Soñamos con una comunidad viva, donde agricultores y consumidores se encuentren sin intermediarios, sin filtros, sin trampas.</p>
                                    <p>Queremos que cada alimento que llegue a tu casa cuente una historia: la de una persona, una familia, una tierra que sigue latiendo.</p>
                                    <p>No vendemos comida. Creamos conexiones reales.</p>
                                    <p>Apoyamos a quienes cultivan con respeto, y lo ofrecemos a quienes buscan una forma distinta —más humana— de alimentarse.</p>
                                    <p>En cada cesta hay algo más que verduras: hay un paso hacia un futuro más justo, más verde, más compartido.</p>
                                    <p>Y tú ya estás formando parte de él.</p>
                                    <p>Queremos recuperar algo que nunca debimos perder: la confianza en lo natural, en lo cercano, en lo que se hace con cariño.</p>
                                    <p>Por eso, en BioCerca, puedes mirar a los ojos a quien cultiva lo que comes.</p>
                                    <p>Soñamos con familias que visitan granjas, niños que aprenden de dónde viene la comida, y personas que vuelven a emocionarse al cocinar algo real.</p>
                                    <p>Sabemos que es posible. Y sabemos que no estamos solos.</p>
                                    <h3>Bienvenid@ a casa. Bienvenid@ a BioCerca.</h3>
                                </div>
                                
                                <div className={css.ctaSection}>
                                    <h2 className={css.ctaTitle}>¿Quieres unirte a la revolución?</h2>
                                    <p className={css.ctaText}>
                                        Cada persona que se une a BioCerca está ayudando a construir un sistema alimentario más justo y sostenible.
                                    </p>
                                    <div className={css.ctaButtons}>
                                        <NamedLink name="SignupPage" className={css.ctaButtonPrimary}>
                                            Únete a BioCerca
                                        </NamedLink>
                                        <NamedLink name="FAQPage" className={css.ctaButtonSecondary}>
                                            Saber más
                                        </NamedLink>
                                    </div>
                                </div>
                            </div>
                        </Main>
                        <Footer>
                            <FooterContainer />
                        </Footer>
                    </>
                );
            }}
        </LayoutComposer>
    );
};

export default AboutPage;
